import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

export default function ResponsiveDialog({ open, handleClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        disableEnforceFocus
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <DialogContentText>
            We will soon discontinue the old website. Still want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "dialogueBox_clicked",
                inquiryType: "",
                buttonName: "Yes",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "",
                Category: "",
                FAQ: "",
              });
              window.open(
                "https://apps.iciciprupms.com/wealthspectrum/portal/"
              );
              handleClose();
            }}
          >
            Yes
          </Button>
          <Button
            onClick={() => {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "dialogueBox_clicked",
                inquiryType: "",
                buttonName: "No",
                email: "", // Encrypted email of the User using SHA-256 encryption
                contactNumber: "", // Encrypted contact Number of the User using SHA-256 encryption
                clientID: "",
                queryMessage: "",
                state: "",
                pageSection: "",
                Category: "",
                FAQ: "",
              });
              window.open("https://www.iciciprualternates.com/portal");
              handleClose();
            }}
            autoFocus
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
